import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'
import { BsArrowLeftCircle } from 'react-icons/bs';

const AboutModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      open={props.isOpened}
      dontApplyListeners={true}
      allowClose={false}
      onRequestClose={props.close}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className={`w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto`}
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                props.backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-green-primary" />
            </div>

            <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-green-primary" />
            </button>
          </div>
        </div>

        <h2 className='text-green-primary font-bold text-xl text-center mx-auto my-8'>Sobre nós</h2>

        <p className='text-lg mb-2'>
          Somos o Conta Outra Vez!, a plataforma de livros para as infâncias que conecta os pequenos leitores aos grandes autores. Todos os meses selecionamos, com todo o cuidado, os títulos digitais que farão parte da primeira biblioteca dos pequenos, para serem compartilhados entre adultos e crianças, numa relação de mediação e descoberta.
        </p>

        <p className='text-lg'>
          O Conta Outra Vez! é operado pela Graviola Digital. Acreditamos no poder da riqueza e da diversidade de nossos autores para formar os cidadãos do futuro, que vão transformar o mundo.
        </p>
      </div>
    </Drawer>
  )
}

export default AboutModal